
 

 

 

 
class StationParameter 
{
    
        DistrictId: string | null;
    
        DistrictGroupId: string | null;
    
        StationId: string | null;
    
        StationName: string;
    
}
 
export default StationParameter;
 




